/*
 * File: AuthenticatedRoutes.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/20/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Authenticated routes for the app.
 * Route components can be used here as the only way to get
 * to these routes is through the AuthenticatedRoute component
 * in Routes.js.
 */

import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { OnlinePayments } from "tsys-online-payments";
import PropTypes from "prop-types";
import PortalUserModel from "stores/models/PortalUserModel";

const AuthenticatedRoutes = ({ user }) => {
  const basename =
    process.env.NODE_ENV === "development" ? "" : process.env.PUBLIC_URL;
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/bill-pay" />
      </Route>
      <Route
        path="/bill-pay"
        render={({ match }) => (
          <OnlinePayments
            patientPortalUserId={user.userId}
            basename={basename + match.path}
          />
        )}
      ></Route>
    </Switch>
  );
};

AuthenticatedRoutes.propTypes = {
  user: PropTypes.instanceOf(PortalUserModel).isRequired
};

export default AuthenticatedRoutes;
